import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Dispatch, SetStateAction } from "react";

import type { SelectedImage } from "../../store";

interface ThumbnailImageProps {
  currentImageIndex: number;
  image: SelectedImage;
  index: number;
  setCurrentImageIndex: Dispatch<SetStateAction<number>>;
}

export const ThumbnailImage = ({
  image,
  index,
  setCurrentImageIndex,
  currentImageIndex,
}: ThumbnailImageProps) => (
  <button
    type="button"
    onPointerDown={() => setCurrentImageIndex(index)}
    onClick={() => setCurrentImageIndex(index)}
    className={classNames(
      "shrink-0 cursor-pointer touch-none select-none rounded-md border-2 border-transparent p-0.5",
      {
        "border-secondary": index === currentImageIndex,
      },
    )}
    key={image.preview}
  >
    <img
      loading="eager"
      src={image.preview}
      className="size-12 rounded-md object-cover"
      alt={image.file.name}
    />
  </button>
);
